<template>
  <v-dialog
    v-model="core.introVideo.visible"
    :style="`z-index: ${core.confirmationIndex + 1};position: fixed;`"
    scrollable
  >
    <v-card>
      <v-toolbar class="dialog_toolbar" dark color="primary">
        <v-toolbar-title>{{
          $t("common.aboutDialog.title_intro_video")
        }}</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-btn icon @click.stop="core.introVideo.visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text style="padding: 0; text-align: center">
        <video
          controls
          autoplay
          ref="video"
          id="video"
          controlsList="nodownload"
          disablePictureInPicture
          style="vertical-align: middle; max-width: 100%; max-height: 100%"
        >
          <source src="../../public/video/gt_intro.mp4" type="video/mp4" />
          <p>
            Your browser does not support the video tag.
            <a href="../../public/gt_intro.mp4">Please click here instead of</a
            >.
          </p>
        </video>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {};
  },
  mounted() {},
  props: ["core"],
  watch: {
    [`core.introVideo.visible`](newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal) {
          $("#video").focus();
          setTimeout(() => {
            $("#video").focus();
          }, 100);
        } else {
          this.$refs.video.pause();
        }
      }
    },
  },
  computed: {},
  methods: {},
};
</script>